<!-- Header -->
<div class="header header-xl">
  <div class="container">
    <!-- Logo -->
    <div class="header-logo">
      <h3 class="uppercase letter-spacing-1"><a routerLink="/">Maximo</a></h3>
    </div>
    <!-- Fullscreen Menu Toggle -->
    <button class="fm-toggle" (click)="toggleMenu()">
      <span class="lines"></span>
    </button>
  </div><!-- end container -->
</div>

<!-- Fullscreen Menu -->
<div class="fullscreen-menu bg-black" [ngClass]="{'fm-show': isMenuOpen}">
  <div class="fm-wrapper">
    <div class="position-middle">
      <div class="container">
        <div class="row g-4">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div class="row g-4 align-items-center">
              <div class="col-12 col-md-6">
                <ul class="list-unstyled">
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/">Home</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/about-us">About</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/portfolio-one">Portfolio</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/blog-grid">Blog</a></h6>
                  </li>
                  <li>
                    <h6 class="fw-semi-bold uppercase letter-spacing-2"><a class="text-link-2" routerLink="/contact">Contact</a></h6>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6">
                <h5 class="fw-semi-bold">Contact Info:</h5>
                <ul class="list-unstyled">
                  <li>Patton Street Caulfield East VIC 3145</li>
                  <li>yoursite&#64;example.com</li>
                </ul>
                <ul class="list-inline-sm mt-4">
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-facebook"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-twitter-x"></i></a></li>
                  <li><a class="button-circle button-circle-sm button-circle-white-2" href="#"><i class="bi bi-instagram"></i></a></li>
                </ul>
              </div>
            </div><!-- end row(inner) -->
          </div>
        </div><!-- end row(outer) -->
      </div><!-- end container -->
    </div><!-- end position-middle -->
    <!-- Close button -->
    <button class="fm-close" (click)="closeMenu()">
      <span></span>
    </button>
  </div><!-- end fm-wrapper -->
</div><!-- end fullscreen-menu -->
<!-- end Header -->

<!-- Gallery section -->
<div class="container">
    <div class="row gallery-wrapper g-4 g-lg-5">
        <!-- Gallery image box -->
        <div *ngFor="let item of galleryItems; let i = index" class="col-12 col-sm-6 col-lg-4 col-xl-3 gallery-box img-class">
            <div class="gallery-img" (click)="openLightbox(i)" role="button" tabindex="0" (keydown.enter)="openLightbox(i)">
                <img [src]="item.imageUrl" [alt]="item.alt" style="width: 100%; height: auto; cursor: pointer;">
            </div>
        </div>
    </div><!-- end row/gallery-wrapper -->
</div><!-- end container -->
<!-- end Gallery section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="row gy-5">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
                <h1 class="fw-bold"><span class="text-gradient-1">Get In Touch</span></h1>
            </div>
            <!-- Contact Form -->
            <div class="col-12 col-lg-8 offset-lg-2">
                <div class="contact-form">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15"
                                        [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                                        placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35"
                                        [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input border-radius"
                                        id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                                        email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                class="md-textarea border-radius" id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message"
                                #userMessage="ngModel" required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                    <!-- Submit result -->
                    <div class="messages mrt-20 text-center"></div>
                </div><!-- end contact-form -->
            </div>
            <!-- end Contact Form -->
        </div><!-- end row -->
        <!-- Contact Info -->
        <div class="row g-4 g-lg-5 text-lg-center mt-5 icon-4xl">
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-telephone text-gradient-1"></i>
                <h5 class="fw-medium mt-2 mb-0">Phone</h5>
                <p>+1 234 567 89</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-envelope text-gradient-1"></i>
                <h5 class="fw-medium mt-2 mb-0">Email</h5>
                <p>contact&#64;yourdomain.com</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-whatsapp text-gradient-1"></i>
                <h5 class="fw-medium mt-2 mb-0">Whatsapp</h5>
                <p>+1 234 567 89</p>
            </div>
            <div class="col-6 col-sm-6 col-lg-3">
                <i class="bi bi-geo-alt text-gradient-1"></i>
                <h5 class="fw-medium mt-2 mb-0">Address</h5>
                <p>Ulaanbaatar, Khan-Uul, 11000</p>
            </div>
        </div><!-- end row -->
        <!-- end Contact Info -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->
